import Service from "../service"

const Auth = {
    login(data) {
        return Service.post("/auth/login", data)
    },
    request(data){
        return Service.post('/auth/request',data);
    },
    update(id, data) {
        return Service.post("/update/" + id, data);
    },
    getUserAll() {
        return Service.get("/get_user");
    },
};

export default Auth;
